import React, { useState, useRef, useEffect } from "react"
import { Edit } from "./Icons"
import Buttons from "./Buttons";
import { updateData } from "../functions/firebaseFunctions";
import { useNavigate } from 'react-router-dom';

const title2id = (title) => {
    return title.replace(/ /g, "_");
}

const placeholders = [
    "Enter Title",
    "Enter Description",
    "Link GitHub"
]

function Field({ type, value, color, inForm, inline, updateValue, fieldPath, width, newProj, test, github }) {

    const Navigate = useNavigate();

    const [editing, setEditing] = useState(false)
    const inputRef = useRef(null);
    const [staticValue, setStaticValue] = useState(undefined);

    //the following few lines are for the disable submit option
    const [inputValue, setInputValue] = useState('');
    const handleInputChange = (event) => {
        setInputValue(event.target.value);//update input
    };

    const update = event => {
        //console.log('update')
        if (inForm) {//for when the submit is disabled we use local state
            //console.log('in form')
            if (inputValue && inputValue !== value) {
                //console.log('value has changed from ', value, ' to ', inputValue,)
                updateValue(inputValue); // if there is a value and the value has changed then update it
            }
        } else {//othervise use the form for processing data
            //console.log('out of form')
            event.preventDefault();
            //console.log('target:', event.target)
            const { input } = event.target;
            if (input.value && input.value !== value) { // if there is a value and the value has changed then update it
                //console.log("value", input.value)
                let path
                let projId
                let value
                if (newProj) { // if it is a new project creation we follow a special precidure
                    projId = title2id(input.value)
                    path = fieldPath + "/" + projId
                    value = {
                        title: input.value,
                        projectId: projId
                    }
                } else if (github) {//if the input needs to be processed before saving to the database then it will happen here
                    path = fieldPath
                    const segments = input.value.split('/');
                    value = {
                        name: segments[segments.length - 1],
                        link: input.value
                    }
                } else { // otherwise we use the default values
                    path = fieldPath
                    value = input.value
                }

                if (test) {
                    console.log('path:', path)
                    console.log('value:', value)
                } else {
                    updateData(path, value).then(UDRes => {
                        //console.log('data updated', UDRes)
                        if (UDRes.success) {
                            setStaticValue(github ? value.name : value);
                            if (newProj) { Navigate(`project/${projId}`); } // Navigate to the newly created project
                            //console.log('value', input.value)
                        } else {
                            setStaticValue(UDRes.message);
                        }
                    })
                }
            }
        }
        setEditing(false)
    }

    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
            inputRef.current.style.height = inputRef.current.scrollHeight + 'px'
        }
    }, [editing]);

    useEffect(() => {
        setStaticValue(value)
    }, [staticValue, value])

    const Static = () => {
        switch (type) {
            case 'h1':
                return (<h1 style={{ color: color === 'orange' ? 'var(--orng)' : color }}>{staticValue || value}</h1>)
            case 'h2':
                return (<h2 style={{ color: color === 'orange' ? 'var(--orng)' : color }}>{staticValue || value}</h2>)
            case 'h3':
                return (<h3 style={{ color: color === 'orange' ? 'var(--orng)' : color }}>{staticValue || value}</h3>)
            case 'h4':
                return (<h4 style={{ color: color === 'orange' ? 'var(--orng)' : color }}>{staticValue || value}</h4>)
            case 'p':
                return (<p style={{ color: color === 'orange' ? 'var(--orng)' : color }}>{staticValue || value}</p>)
            default:
                return (<div>Unknown Type</div>)
        }
    }



    const outerStyle = {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        width: type === 'p' ? '100%' : 'fit-content',
        margin: '0 auto',
        alignItems: 'center',
        borderWidth: 0,
        gap: 5,
    }

    const textAreaStyle = {
        width: "100%",
        borderRadius: 10,
        padding: 10,
        fontSize: 15,
        marginTop: 5,
        height: "100%"
    }
    if (editing) {
        if (inForm) {
            return (
                <div style={outerStyle}>
                    {type === "p"
                        ? <textarea
                            name='input'
                            defaultValue={placeholders.includes(value) ? null : (staticValue || value)}
                            placeholder={placeholders.includes(value) ? value : undefined}
                            className={type}
                            onChange={handleInputChange}
                            ref={inputRef}
                            onInput={element => {
                                // This function adjust the height of the text area to fit all the text
                                element.target.style.height = element.target.scrollHeight + 'px'
                            }}
                        />
                        :
                        <input
                            name='input'
                            style={{ width: width }}
                            defaultValue={placeholders.includes(value) ? null : (staticValue || value)}
                            placeholder={placeholders.includes(value) ? value : undefined}
                            className={type}
                            onChange={handleInputChange}
                            ref={inputRef}
                        />
                    }
                    <Buttons color={color} inForm={inForm} inline={inline} update={update} cancelAction={() => { setEditing(false) }} />
                </div>
            )
        } else {
            return (
                <form style={outerStyle} onSubmit={event => { update(event) }}>
                    {type === 'p' ?
                        <textarea
                            style={textAreaStyle}
                            name='input'
                            defaultValue={placeholders.includes(value) ? null : (staticValue || value)}
                            placeholder={placeholders.includes(value) ? value : undefined}
                            className={type}
                            ref={inputRef}
                            onInput={element => {
                                // This function adjust the height of the text area to fit all the text
                                element.target.style.height = element.target.scrollHeight + 'px'
                            }}
                        />
                        :
                        <input
                            name='input'
                            style={{ width: width }}
                            defaultValue={placeholders.includes(value) ? null : (staticValue || value)}
                            placeholder={placeholders.includes(value) ? value : undefined}
                            className={type}
                            ref={inputRef}
                        />
                    }
                    <Buttons inline={inline} color={color} inForm={inForm} update={update} cancelAction={() => { setEditing(false) }} />
                </form>
            )
        }
    } else {
        return (
            <div style={outerStyle}>
                <Static />
                <button className={`${color}IconBtn`} type="button"
                    onClick={() => { setEditing(true); }}
                >
                    <Edit />
                </button>
            </div>
        )
    }
}

export default Field